// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700;800&family=Geist+Mono:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
        --background: 0 0% 100%;
        --foreground: 222 47% 11%;
        --card: 0 0% 100%;
        --card-foreground: 222 47% 11%;
        --popover: 0 0% 100%;
        --popover-foreground: 222 47% 11%;
        --primary: 243 75% 59%;
        --primary-foreground: 0 0% 100%;
        --secondary: 210 40% 96%;
        --secondary-foreground: 222 47% 11%;
        --muted: 210 40% 96%;
        --muted-foreground: 215 16% 47%;
        --accent: 210 40% 96%;
        --accent-foreground: 222 47% 11%;
        --destructive: 346 84% 47%;
        --destructive-foreground: 0 0% 100%;
        --border: 214 32% 91%;
        --input: 214 32% 91%;
        --ring: 243 75% 59%;
        --chart-1: 243 75% 59%;
        --chart-2: 160 84% 39%;
        --chart-3: 199 89% 48%;
        --chart-4: 38 92% 50%;
        --chart-5: 346 84% 47%;
        --radius: 0.5rem;
    }

*{
  border-color: hsl(var(--border));
}

body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
        font-feature-settings:
            "rlig" 1,
            "calt" 1;
}

::selection {
        background: hsl(243 75% 59% / 0.18);
        color: hsl(243 75% 30%);
    }

[data-debug-wrapper="true"] {
        display: contents !important;
    }

[data-debug-wrapper="true"] > * {
        margin-left: inherit;
        margin-right: inherit;
        margin-top: inherit;
        margin-bottom: inherit;
        padding-left: inherit;
        padding-right: inherit;
        padding-top: inherit;
        padding-bottom: inherit;
        column-gap: inherit;
        row-gap: inherit;
        gap: inherit;
        border-left-width: inherit;
        border-right-width: inherit;
        border-top-width: inherit;
        border-bottom-width: inherit;
    }
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-32{
  bottom: -8rem;
}
.-bottom-4{
  bottom: -1rem;
}
.-left-1{
  left: -0.25rem;
}
.-left-12{
  left: -3rem;
}
.-left-20{
  left: -5rem;
}
.-right-0{
  right: -0px;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-12{
  right: -3rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-20{
  right: -5rem;
}
.-right-24{
  right: -6rem;
}
.-top-0{
  top: -0px;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-12{
  top: -3rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-2\\.5{
  top: -0.625rem;
}
.-top-20{
  top: -5rem;
}
.-top-24{
  top: -6rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-0\\.5{
  bottom: 0.125rem;
}
.bottom-1\\.5{
  bottom: 0.375rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-20{
  bottom: 5rem;
}
.bottom-4{
  bottom: 1rem;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-5{
  left: 1.25rem;
}
.left-6{
  left: 1.5rem;
}
.left-\\[28\\%\\]{
  left: 28%;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.left-\\[72\\%\\]{
  left: 72%;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-\\[calc\\(100\\%\\+6px\\)\\]{
  top: calc(100% + 6px);
}
.top-full{
  top: 100%;
}
.\\!z-\\[1\\]{
  z-index: 1 !important;
}
.-z-10{
  z-index: -10;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.col-span-10{
  grid-column: span 10 / span 10;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-8{
  grid-column: span 8 / span 8;
}
.col-span-9{
  grid-column: span 9 / span 9;
}
.\\!m-2{
  margin: 0.5rem !important;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.m-\\[1px\\]{
  margin: 1px;
}
.-mx-0\\.5{
  margin-left: -0.125rem;
  margin-right: -0.125rem;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5{
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-0\\.5{
  margin-right: -0.125rem;
}
.-mt-0\\.5{
  margin-top: -0.125rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-4{
  margin-top: -1rem;
}
.-mt-\\[1\\.7em\\]{
  margin-top: -1.7em;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-32{
  margin-left: 8rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.inline-grid{
  display: inline-grid;
}
.contents{
  display: contents;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.aspect-\\[5\\/4\\]{
  aspect-ratio: 5/4;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.\\!h-2\\.5{
  height: 0.625rem !important;
}
.h-0{
  height: 0px;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-60{
  height: 15rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[112px\\]{
  height: 112px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[240px\\]{
  height: 240px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[76px\\]{
  height: 76px;
}
.h-\\[88px\\]{
  height: 88px;
}
.h-\\[92px\\]{
  height: 92px;
}
.h-\\[calc\\(100dvh-72px\\)\\]{
  height: calc(100dvh - 72px);
}
.h-\\[calc\\(100vh-90px\\)\\]{
  height: calc(100vh - 90px);
}
.h-\\[min\\(480px\\2c 52dvh\\)\\]{
  height: min(480px, 52dvh);
}
.h-\\[min\\(520px\\2c 55dvh\\)\\]{
  height: min(520px, 55dvh);
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-dvh{
  height: 100dvh;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.\\!max-h-none{
  max-height: none !important;
}
.max-h-16{
  max-height: 4rem;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-28{
  max-height: 7rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[260px\\]{
  max-height: 260px;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[420px\\]{
  max-height: 420px;
}
.max-h-\\[60px\\]{
  max-height: 60px;
}
.max-h-\\[65vh\\]{
  max-height: 65vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[88vh\\]{
  max-height: 88vh;
}
.max-h-\\[90dvh\\]{
  max-height: 90dvh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[calc\\(100vh-220px\\)\\]{
  max-height: calc(100vh - 220px);
}
.max-h-\\[min\\(320px\\2c 50dvh\\)\\]{
  max-height: min(320px, 50dvh);
}
.max-h-\\[min\\(48dvh\\2c 420px\\)\\]{
  max-height: min(48dvh, 420px);
}
.max-h-\\[min\\(92dvh\\2c 720px\\)\\]{
  max-height: min(92dvh, 720px);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-none{
  max-height: none;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-10{
  min-height: 2.5rem;
}
.min-h-11{
  min-height: 2.75rem;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-14{
  min-height: 3.5rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-9{
  min-height: 2.25rem;
}
.min-h-\\[112px\\]{
  min-height: 112px;
}
.min-h-\\[12rem\\]{
  min-height: 12rem;
}
.min-h-\\[180px\\]{
  min-height: 180px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[420px\\]{
  min-height: 420px;
}
.min-h-\\[50vh\\]{
  min-height: 50vh;
}
.min-h-\\[52px\\]{
  min-height: 52px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[65px\\]{
  min-height: 65px;
}
.min-h-\\[72px\\]{
  min-height: 72px;
}
.min-h-\\[76px\\]{
  min-height: 76px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[96px\\]{
  min-height: 96px;
}
.min-h-\\[calc\\(100dvh-11rem\\)\\]{
  min-height: calc(100dvh - 11rem);
}
.min-h-dvh{
  min-height: 100dvh;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-2\\.5{
  width: 0.625rem !important;
}
.w-0{
  width: 0px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[108px\\]{
  width: 108px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[168px\\]{
  width: 168px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[232px\\]{
  width: 232px;
}
.w-\\[24\\%\\]{
  width: 24%;
}
.w-\\[25\\.3\\%\\]{
  width: 25.3%;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[268px\\]{
  width: 268px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[340px\\]{
  width: 340px;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[440px\\]{
  width: 440px;
}
.w-\\[460px\\]{
  width: 460px;
}
.w-\\[520px\\]{
  width: 520px;
}
.w-\\[64px\\]{
  width: 64px;
}
.w-\\[78\\%\\]{
  width: 78%;
}
.w-\\[calc\\(100vw-1\\.5rem\\)\\]{
  width: calc(100vw - 1.5rem);
}
.w-\\[min\\(100\\%\\2c 280px\\)\\]{
  width: min(100%, 280px);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[1\\.25rem\\]{
  min-width: 1.25rem;
}
.min-w-\\[128px\\]{
  min-width: 128px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[148px\\]{
  min-width: 148px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[240px\\]{
  min-width: 240px;
}
.min-w-\\[260px\\]{
  min-width: 260px;
}
.min-w-\\[4\\.5rem\\]{
  min-width: 4.5rem;
}
.min-w-\\[480px\\]{
  min-width: 480px;
}
.min-w-\\[52px\\]{
  min-width: 52px;
}
.min-w-\\[560px\\]{
  min-width: 560px;
}
.min-w-\\[640px\\]{
  min-width: 640px;
}
.min-w-\\[720px\\]{
  min-width: 720px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[920px\\]{
  min-width: 920px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.min-w-full{
  min-width: 100%;
}
.\\!max-w-none{
  max-width: none !important;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[100vw\\]{
  max-width: 100vw;
}
.max-w-\\[1100px\\]{
  max-width: 1100px;
}
.max-w-\\[1120px\\]{
  max-width: 1120px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[12rem\\]{
  max-width: 12rem;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[340px\\]{
  max-width: 340px;
}
.max-w-\\[360px\\]{
  max-width: 360px;
}
.max-w-\\[380px\\]{
  max-width: 380px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[40vw\\]{
  max-width: 40vw;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[45\\%\\]{
  max-width: 45%;
}
.max-w-\\[460px\\]{
  max-width: 460px;
}
.max-w-\\[480px\\]{
  max-width: 480px;
}
.max-w-\\[560px\\]{
  max-width: 560px;
}
.max-w-\\[600px\\]{
  max-width: 600px;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[75\\%\\]{
  max-width: 75%;
}
.max-w-\\[8\\.5rem\\]{
  max-width: 8.5rem;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[900px\\]{
  max-width: 900px;
}
.max-w-\\[960px\\]{
  max-width: 960px;
}
.max-w-\\[9rem\\]{
  max-width: 9rem;
}
.max-w-\\[min\\(320px\\2c 90vw\\)\\]{
  max-width: min(320px, 90vw);
}
.max-w-\\[min\\(85\\%\\2c 42rem\\)\\]{
  max-width: min(85%, 42rem);
}
.max-w-\\[min\\(88\\%\\2c 48rem\\)\\]{
  max-width: min(88%, 48rem);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-none{
  flex: none;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-32{
  flex-basis: 8rem;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-help{
  cursor: help;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-row-resize{
  cursor: row-resize;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.scroll-mt-4{
  scroll-margin-top: 1rem;
}
.list-inside{
  list-style-position: inside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[220px_1fr\\]{
  grid-template-columns: 220px 1fr;
}
.grid-cols-\\[240px_1fr\\]{
  grid-template-columns: 240px 1fr;
}
.grid-cols-\\[36px_repeat\\(12\\2c 1fr\\)\\]{
  grid-template-columns: 36px repeat(12,1fr);
}
.grid-rows-\\[0fr\\]{
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\]{
  grid-template-rows: 1fr;
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-1\\.5{
  column-gap: 0.375rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.divide-slate-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-divide-opacity, 1));
}
.divide-slate-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-x-clip{
  overflow-x: clip;
}
.overscroll-contain{
  overscroll-behavior: contain;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-\\[var\\(--radius-lg\\2c 16px\\)\\]{
  border-radius: var(--radius-lg,16px);
}
.rounded-\\[var\\(--radius-md\\2c 12px\\)\\]{
  border-radius: var(--radius-md,12px);
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl{
  border-bottom-left-radius: 0.25rem;
}
.rounded-bl-sm{
  border-bottom-left-radius: calc(var(--radius) - 4px);
}
.rounded-br{
  border-bottom-right-radius: 0.25rem;
}
.rounded-br-md{
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-br-sm{
  border-bottom-right-radius: calc(var(--radius) - 4px);
}
.rounded-tl{
  border-top-left-radius: 0.25rem;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.rounded-tr{
  border-top-right-radius: 0.25rem;
}
.\\!border-2{
  border-width: 2px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-white{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[var\\(--slate-200\\2c \\#E2E8F0\\)\\]{
  border-color: var(--slate-200,#E2E8F0);
}
.border-\\[var\\(--slate-300\\2c \\#CBD5E1\\)\\]{
  border-color: var(--slate-300,#CBD5E1);
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-300\\/70{
  border-color: rgb(252 211 77 / 0.7);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-300\\/70{
  border-color: rgb(110 231 183 / 0.7);
}
.border-fuchsia-200{
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/70{
  border-color: rgb(199 210 254 / 0.7);
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-rose-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/60{
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-200\\/70{
  border-color: rgb(226 232 240 / 0.7);
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-300\\/70{
  border-color: rgb(203 213 225 / 0.7);
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity, 1));
}
.border-violet-400{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-l-indigo-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.\\!bg-emerald-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-slate-400{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#f1f3f4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 243 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f9fa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--indigo-50\\2c \\#EEF2FF\\)\\]{
  background-color: var(--indigo-50,#EEF2FF);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-100\\/80{
  background-color: rgb(254 243 199 / 0.8);
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/30{
  background-color: rgb(255 251 235 / 0.3);
}
.bg-amber-50\\/40{
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/50{
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/60{
  background-color: rgb(255 251 235 / 0.6);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-amber-700{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/30{
  background-color: rgb(236 253 245 / 0.3);
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/50{
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-50\\/60{
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-fuchsia-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100\\/60{
  background-color: rgb(224 231 255 / 0.6);
}
.bg-indigo-200\\/40{
  background-color: rgb(199 210 254 / 0.4);
}
.bg-indigo-400{
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/20{
  background-color: rgb(238 242 255 / 0.2);
}
.bg-indigo-50\\/30{
  background-color: rgb(238 242 255 / 0.3);
}
.bg-indigo-50\\/40{
  background-color: rgb(238 242 255 / 0.4);
}
.bg-indigo-50\\/50{
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-50\\/60{
  background-color: rgb(238 242 255 / 0.6);
}
.bg-indigo-50\\/70{
  background-color: rgb(238 242 255 / 0.7);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/30{
  background-color: rgb(255 241 242 / 0.3);
}
.bg-rose-50\\/40{
  background-color: rgb(255 241 242 / 0.4);
}
.bg-rose-50\\/50{
  background-color: rgb(255 241 242 / 0.5);
}
.bg-rose-50\\/80{
  background-color: rgb(255 241 242 / 0.8);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-50\\/40{
  background-color: rgb(240 249 255 / 0.4);
}
.bg-sky-50\\/50{
  background-color: rgb(240 249 255 / 0.5);
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/20{
  background-color: rgb(248 250 252 / 0.2);
}
.bg-slate-50\\/30{
  background-color: rgb(248 250 252 / 0.3);
}
.bg-slate-50\\/40{
  background-color: rgb(248 250 252 / 0.4);
}
.bg-slate-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/60{
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-50\\/70{
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80{
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-50\\/95{
  background-color: rgb(248 250 252 / 0.95);
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-200\\/30{
  background-color: rgb(221 214 254 / 0.3);
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85{
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-amber-400{
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50{
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400{
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50{
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/30{
  --tw-gradient-from: rgb(236 253 245 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/60{
  --tw-gradient-from: rgb(236 253 245 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-50\\/60{
  --tw-gradient-from: rgb(253 244 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 244 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-100{
  --tw-gradient-from: #e0e7ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-100\\/70{
  --tw-gradient-from: rgb(224 231 255 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400{
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50{
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/30{
  --tw-gradient-from: rgb(238 242 255 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/40{
  --tw-gradient-from: rgb(238 242 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/50{
  --tw-gradient-from: rgb(238 242 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/60{
  --tw-gradient-from: rgb(238 242 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/70{
  --tw-gradient-from: rgb(238 242 255 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/80{
  --tw-gradient-from: rgb(238 242 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-400{
  --tw-gradient-from: #fb7185 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 113 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500{
  --tw-gradient-from: #f43f5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-400{
  --tw-gradient-from: #38bdf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500{
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-200{
  --tw-gradient-from: #e2e8f0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-300{
  --tw-gradient-from: #cbd5e1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(203 213 225 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-400{
  --tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900{
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-400{
  --tw-gradient-from: #a78bfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(167 139 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-indigo-50\\/30{
  --tw-gradient-to: rgb(238 242 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(238 242 255 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-100\\/40{
  --tw-gradient-to: rgb(237 233 254 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(237 233 254 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-600{
  --tw-gradient-to: rgb(124 58 237 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #7c3aed var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-500{
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}
.to-emerald-50\\/40{
  --tw-gradient-to: rgb(236 253 245 / 0.4) var(--tw-gradient-to-position);
}
.to-emerald-500{
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-emerald-600{
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-indigo-50\\/20{
  --tw-gradient-to: rgb(238 242 255 / 0.2) var(--tw-gradient-to-position);
}
.to-indigo-50\\/40{
  --tw-gradient-to: rgb(238 242 255 / 0.4) var(--tw-gradient-to-position);
}
.to-indigo-500{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-700{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
.to-orange-50\\/30{
  --tw-gradient-to: rgb(255 247 237 / 0.3) var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-rose-50\\/40{
  --tw-gradient-to: rgb(255 241 242 / 0.4) var(--tw-gradient-to-position);
}
.to-sky-500{
  --tw-gradient-to: #0ea5e9 var(--tw-gradient-to-position);
}
.to-slate-300{
  --tw-gradient-to: #cbd5e1 var(--tw-gradient-to-position);
}
.to-slate-50\\/40{
  --tw-gradient-to: rgb(248 250 252 / 0.4) var(--tw-gradient-to-position);
}
.to-slate-500{
  --tw-gradient-to: #64748b var(--tw-gradient-to-position);
}
.to-slate-800{
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-violet-100{
  --tw-gradient-to: #ede9fe var(--tw-gradient-to-position);
}
.to-violet-50{
  --tw-gradient-to: #f5f3ff var(--tw-gradient-to-position);
}
.to-violet-50\\/20{
  --tw-gradient-to: rgb(245 243 255 / 0.2) var(--tw-gradient-to-position);
}
.to-violet-50\\/30{
  --tw-gradient-to: rgb(245 243 255 / 0.3) var(--tw-gradient-to-position);
}
.to-violet-50\\/40{
  --tw-gradient-to: rgb(245 243 255 / 0.4) var(--tw-gradient-to-position);
}
.to-violet-500{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-violet-600{
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.fill-amber-500{
  fill: #f59e0b;
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[9px\\]{
  padding-top: 9px;
  padding-bottom: 9px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[max\\(0\\.75rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
}
.pl-0{
  padding-left: 0px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-\\[ui-sans-serif\\]{
  font-family: ui-sans-serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-serif{
  font-family: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[0\\.85em\\]{
  font-size: 0.85em;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14\\.5px\\]{
  font-size: 14.5px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[44px\\]{
  font-size: 44px;
}
.text-\\[56px\\]{
  font-size: 56px;
}
.text-\\[8\\.5px\\]{
  font-size: 8.5px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9\\.5px\\]{
  font-size: 9.5px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.05\\]{
  line-height: 1.05;
}
.leading-\\[1\\.1\\]{
  line-height: 1.1;
}
.leading-\\[1\\.85\\]{
  line-height: 1.85;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.35em\\]{
  letter-spacing: 0.35em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#202124\\]{
  --tw-text-opacity: 1;
  color: rgb(32 33 36 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--indigo\\2c \\#4F46E5\\)\\]{
  color: var(--indigo,#4F46E5);
}
.text-\\[var\\(--slate-400\\2c \\#94A3B8\\)\\]{
  color: var(--slate-400,#94A3B8);
}
.text-\\[var\\(--slate-600\\2c \\#475569\\)\\]{
  color: var(--slate-600,#475569);
}
.text-\\[var\\(--slate-700\\2c \\#334155\\)\\]{
  color: var(--slate-700,#334155);
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950{
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-cyan-700\\/90{
  color: rgb(14 116 144 / 0.9);
}
.text-cyan-800{
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-emerald-900\\/80{
  color: rgb(6 78 59 / 0.8);
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-fuchsia-700{
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-indigo-100{
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-800\\/90{
  color: rgb(159 18 57 / 0.9);
}
.text-rose-900{
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.caret-slate-800{
  caret-color: #1e293b;
}
.accent-emerald-600{
  accent-color: #059669;
}
.accent-indigo-600{
  accent-color: #4f46e5;
}
.accent-violet-600{
  accent-color: #7c3aed;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_28px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 12px 28px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-amber-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 243 199 / var(--tw-ring-opacity, 1));
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-amber-200\\/80{
  --tw-ring-color: rgb(253 230 138 / 0.8);
}
.ring-amber-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-blue-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.ring-blue-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.ring-cyan-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 243 252 / var(--tw-ring-opacity, 1));
}
.ring-emerald-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.ring-emerald-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.ring-emerald-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}
.ring-emerald-700{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 120 87 / var(--tw-ring-opacity, 1));
}
.ring-fuchsia-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 208 254 / var(--tw-ring-opacity, 1));
}
.ring-green-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}
.ring-indigo-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.ring-indigo-200\\/50{
  --tw-ring-color: rgb(199 210 254 / 0.5);
}
.ring-indigo-200\\/70{
  --tw-ring-color: rgb(199 210 254 / 0.7);
}
.ring-indigo-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
.ring-indigo-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.ring-indigo-400\\/70{
  --tw-ring-color: rgb(129 140 248 / 0.7);
}
.ring-indigo-50{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(238 242 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500\\/20{
  --tw-ring-color: rgb(99 102 241 / 0.2);
}
.ring-indigo-600{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity, 1));
}
.ring-orange-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}
.ring-pink-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 207 232 / var(--tw-ring-opacity, 1));
}
.ring-purple-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.ring-red-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-rose-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 228 230 / var(--tw-ring-opacity, 1));
}
.ring-rose-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.ring-sky-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 242 254 / var(--tw-ring-opacity, 1));
}
.ring-sky-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.ring-slate-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity, 1));
}
.ring-slate-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-slate-200\\/60{
  --tw-ring-color: rgb(226 232 240 / 0.6);
}
.ring-slate-200\\/70{
  --tw-ring-color: rgb(226 232 240 / 0.7);
}
.ring-slate-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(203 213 225 / var(--tw-ring-opacity, 1));
}
.ring-slate-700{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(51 65 85 / var(--tw-ring-opacity, 1));
}
.ring-slate-800{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 41 59 / var(--tw-ring-opacity, 1));
}
.ring-slate-900{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1));
}
.ring-violet-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/25{
  --tw-ring-color: rgb(255 255 255 / 0.25);
}
.ring-white\\/40{
  --tw-ring-color: rgb(255 255 255 / 0.4);
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\]{
  transition-property: grid-template-rows;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in{
  --tw-enter-opacity: 0;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-50{
  --tw-enter-scale: .5;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\!running{
  animation-play-state: running !important;
}
.running{
  animation-play-state: running;
}
.paused{
  animation-play-state: paused;
}
.scrollbar-thin::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
.scrollbar-thin::-webkit-scrollbar-thumb {
        background: hsl(215 20% 85%);
        border-radius: 3px;
    }
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
        background: hsl(215 20% 70%);
    }
.scrollbar-thin::-webkit-scrollbar-track {
        background: transparent;
    }
.bg-grid {
        background-image:
            linear-gradient(to right, hsl(214 32% 91% / 0.4) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(214 32% 91% / 0.4) 1px, transparent 1px);
        background-size: 32px 32px;
    }
.ring-focus:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
}
.\\[animation-delay\\:120ms\\]{
  animation-delay: 120ms;
}
.\\[animation-delay\\:240ms\\]{
  animation-delay: 240ms;
}
.\\[overflow-wrap\\:anywhere\\]{
  overflow-wrap: anywhere;
}
.\\[scrollbar-width\\:none\\]{
  scrollbar-width: none;
}
.\\[word-break\\:break-word\\]{
  word-break: break-word;
}

body {
    margin: 0;
    font-family: "Geist", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings:
        "ss01" on,
        "cv11" on;
}

code,
pre,
.font-mono {
    font-family:
        "Geist Mono", "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo,
        Consolas, monospace;
}

/* PasswordInput — hide native reveal/clear controls (custom toggle only). */
.password-input-field::-ms-reveal,
.password-input-field::-ms-clear {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
}

.password-input-field::-webkit-credentials-auto-fill-button,
.password-input-field::-webkit-password-reveal-button,
.password-input-field::-webkit-caps-lock-indicator {
    appearance: none !important;
    display: none !important;
    visibility: hidden !important;
    pointer-events: none !important;
    width: 0 !important;
    height: 0 !important;
    margin: 0 !important;
    opacity: 0 !important;
}

.password-input-field::-moz-password-reveal {
    display: none !important;
}

.password-input-field[type="password"]::-webkit-textfield-decoration-container {
    visibility: hidden !important;
    pointer-events: none !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
}

/* Streaming dot animation */
@keyframes pulse-soft {
    0%, 100% { opacity: 0.4; transform: scale(0.85); }
    50% { opacity: 1; transform: scale(1); }
}
.pulse-dot {
    animation: pulse-soft 1.1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Typing cursor */
@keyframes blink {
    0%, 49% { opacity: 1; }
    50%, 100% { opacity: 0; }
}
.typing-cursor::after {
    content: "▍";
    margin-left: 1px;
    color: hsl(243 75% 59%);
    animation: blink 1s steps(1) infinite;
}

/* Native <dialog> overlays: strip UA light-gray sheet; keep positioning only. */
dialog.modal-overlay {
    background: transparent !important;
    border: none;
    padding: 0;
    max-width: none;
    max-height: none;
    width: 100%;
    height: 100%;
    margin: 0;
    color: inherit;
}
dialog.modal-overlay::backdrop {
    background: transparent;
}

/* Brain playground: render server-sanitized answer_html only (formatting done in API). */
.brain-playground-answer {
    font-size: 13px;
    line-height: 1.55;
    color: rgb(30 41 59);
    word-break: break-word;
}
.brain-playground-answer p {
    margin: 0 0 0.65em;
}
.brain-playground-answer p:last-child {
    margin-bottom: 0;
}
.brain-playground-answer ul,
.brain-playground-answer ol {
    margin: 0.5em 0;
    padding-left: 1.25rem;
}
.brain-playground-answer ul {
    list-style-type: disc;
}
.brain-playground-answer ol {
    list-style-type: decimal;
}
.brain-playground-answer li {
    margin: 0.2em 0;
}
.brain-playground-answer strong,
.brain-playground-answer b {
    font-weight: 600;
}
.brain-playground-answer table {
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    margin: 0.65em 0;
    font-size: 12px;
}
.brain-playground-answer th,
.brain-playground-answer td {
    border: 1px solid rgb(203 213 225);
    padding: 0.4em 0.55em;
    vertical-align: top;
    text-align: left;
    word-break: break-word;
}
.brain-playground-answer th {
    background: rgb(241 245 249);
    font-weight: 600;
}
.brain-playground-answer--plain {
    white-space: pre-wrap;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.before\\:mr-1\\.5::before{
  content: var(--tw-content);
  margin-right: 0.375rem;
}
.before\\:not-italic::before{
  content: var(--tw-content);
  font-style: normal;
}
.before\\:text-indigo-400::before{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.before\\:content-\\[\\'\\2022\\'\\]::before{
  --tw-content: '•';
  content: var(--tw-content);
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.first\\:border-t-0:first-child{
  border-top-width: 0px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.focus-within\\:border-indigo-500:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-indigo-500\\/30:focus-within{
  --tw-ring-color: rgb(99 102 241 / 0.3);
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-indigo-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[var\\(--slate-50\\2c \\#F8FAFC\\)\\]:hover{
  background-color: var(--slate-50,#F8FAFC);
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50\\/30:hover{
  background-color: rgb(238 242 255 / 0.3);
}
.hover\\:bg-indigo-50\\/40:hover{
  background-color: rgb(238 242 255 / 0.4);
}
.hover\\:bg-indigo-50\\/50:hover{
  background-color: rgb(238 242 255 / 0.5);
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-inherit:hover{
  background-color: inherit;
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100\\/80:hover{
  background-color: rgb(255 228 230 / 0.8);
}
.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50\\/40:hover{
  background-color: rgb(248 250 252 / 0.4);
}
.hover\\:bg-slate-50\\/50:hover{
  background-color: rgb(248 250 252 / 0.5);
}
.hover\\:bg-slate-50\\/60:hover{
  background-color: rgb(248 250 252 / 0.6);
}
.hover\\:bg-slate-50\\/70:hover{
  background-color: rgb(248 250 252 / 0.7);
}
.hover\\:bg-slate-50\\/80:hover{
  background-color: rgb(248 250 252 / 0.8);
}
.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/70:hover{
  background-color: rgb(255 255 255 / 0.7);
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-amber-800:hover{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-700:hover{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-900:hover{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-700:hover{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-800:hover{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-70:hover{
  opacity: 0.7;
}
.hover\\:shadow-\\[0_2px_12px_-2px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.10\\)\\]:hover{
  --tw-shadow: 0 2px 12px -2px rgba(99,102,241,0.10);
  --tw-shadow-colored: 0 2px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_2px_12px_-2px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.15\\)\\]:hover{
  --tw-shadow: 0 2px 12px -2px rgba(99,102,241,0.15);
  --tw-shadow-colored: 0 2px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_4px_20px_-6px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]:hover{
  --tw-shadow: 0 4px 20px -6px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 4px 20px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:bg-rose-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:text-rose-700:focus{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-indigo-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500\\/30:focus{
  --tw-ring-color: rgb(99 102 241 / 0.3);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:pointer-events-auto:focus-visible{
  pointer-events: auto;
}
.focus-visible\\:opacity-100:focus-visible{
  opacity: 1;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-indigo-200:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-indigo-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-rose-200:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-rose-400:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 113 133 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.active\\:bg-indigo-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-default:disabled{
  cursor: default;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-100:disabled{
  opacity: 1;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.group:hover .group-hover\\:pointer-events-auto{
  pointer-events: auto;
}
.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:focus-visible .group-focus-visible\\:opacity-100{
  opacity: 1;
}
.group.toast .group-\\[\\.toast\\]\\:whitespace-pre-wrap{
  white-space: pre-wrap;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toast .group-\\[\\.toast\\]\\:border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:pr-9{
  padding-right: 2.25rem;
}
.group.toast .group-\\[\\.toast\\]\\:text-\\[12px\\]{
  font-size: 12px;
}
.group.toast .group-\\[\\.toast\\]\\:text-\\[13px\\]{
  font-size: 13px;
}
.group.toast .group-\\[\\.toast\\]\\:font-semibold{
  font-weight: 600;
}
.group.toast .group-\\[\\.toast\\]\\:leading-relaxed{
  line-height: 1.625;
}
.group.toast .group-\\[\\.toast\\]\\:leading-snug{
  line-height: 1.375;
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.toast .group-\\[\\.toast\\]\\:hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[state\\=active\\]\\:flex[data-state="active"]{
  display: flex;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[state\\=active\\]\\:flex-col[data-state="active"]{
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=active\\]\\:bg-slate-100[data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
@media (min-width: 640px){

  .sm\\:not-sr-only{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:right-1\\.5{
    right: 0.375rem;
  }

  .sm\\:right-2{
    right: 0.5rem;
  }

  .sm\\:top-1\\.5{
    top: 0.375rem;
  }

  .sm\\:top-2{
    top: 0.5rem;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:-ml-3{
    margin-left: -0.75rem;
  }

  .sm\\:ml-2{
    margin-left: 0.5rem;
  }

  .sm\\:ml-auto{
    margin-left: auto;
  }

  .sm\\:mr-auto{
    margin-right: auto;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-2{
    margin-top: 0.5rem;
  }

  .sm\\:mt-3{
    margin-top: 0.75rem;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:mt-8{
    margin-top: 2rem;
  }

  .sm\\:line-clamp-2{
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-20{
    height: 5rem;
  }

  .sm\\:h-4{
    height: 1rem;
  }

  .sm\\:h-56{
    height: 14rem;
  }

  .sm\\:h-6{
    height: 1.5rem;
  }

  .sm\\:h-60{
    height: 15rem;
  }

  .sm\\:h-7{
    height: 1.75rem;
  }

  .sm\\:h-8{
    height: 2rem;
  }

  .sm\\:h-9{
    height: 2.25rem;
  }

  .sm\\:h-\\[260px\\]{
    height: 260px;
  }

  .sm\\:min-h-0{
    min-height: 0px;
  }

  .sm\\:min-h-10{
    min-height: 2.5rem;
  }

  .sm\\:min-h-\\[400px\\]{
    min-height: 400px;
  }

  .sm\\:w-20{
    width: 5rem;
  }

  .sm\\:w-6{
    width: 1.5rem;
  }

  .sm\\:w-7{
    width: 1.75rem;
  }

  .sm\\:w-8{
    width: 2rem;
  }

  .sm\\:w-\\[420px\\]{
    width: 420px;
  }

  .sm\\:w-\\[480px\\]{
    width: 480px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:min-w-\\[220px\\]{
    min-width: 220px;
  }

  .sm\\:min-w-\\[240px\\]{
    min-width: 240px;
  }

  .sm\\:max-w-\\[11rem\\]{
    max-width: 11rem;
  }

  .sm\\:max-w-\\[16rem\\]{
    max-width: 16rem;
  }

  .sm\\:max-w-\\[260px\\]{
    max-width: 260px;
  }

  .sm\\:max-w-\\[400px\\]{
    max-width: 400px;
  }

  .sm\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .sm\\:max-w-\\[440px\\]{
    max-width: 440px;
  }

  .sm\\:max-w-\\[460px\\]{
    max-width: 460px;
  }

  .sm\\:max-w-\\[480px\\]{
    max-width: 480px;
  }

  .sm\\:max-w-\\[500px\\]{
    max-width: 500px;
  }

  .sm\\:max-w-\\[520px\\]{
    max-width: 520px;
  }

  .sm\\:max-w-\\[560px\\]{
    max-width: 560px;
  }

  .sm\\:max-w-\\[600px\\]{
    max-width: 600px;
  }

  .sm\\:max-w-\\[640px\\]{
    max-width: 640px;
  }

  .sm\\:max-w-\\[80\\%\\]{
    max-width: 80%;
  }

  .sm\\:max-w-\\[920px\\]{
    max-width: 920px;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-none{
    max-width: none;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xl{
    max-width: 36rem;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[1fr_auto\\]{
    grid-template-columns: 1fr auto;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:items-baseline{
    align-items: baseline;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-1{
    gap: 0.25rem;
  }

  .sm\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .sm\\:gap-10{
    gap: 2.5rem;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-5{
    gap: 1.25rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .sm\\:self-auto{
    align-self: auto;
  }

  .sm\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-12{
    padding: 3rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-7{
    padding: 1.75rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .sm\\:py-0\\.5{
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }

  .sm\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-12{
    padding-bottom: 3rem;
  }

  .sm\\:pl-10{
    padding-left: 2.5rem;
  }

  .sm\\:pt-16{
    padding-top: 4rem;
  }

  .sm\\:pt-6{
    padding-top: 1.5rem;
  }

  .sm\\:pt-8{
    padding-top: 2rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:text-\\[11\\.5px\\]{
    font-size: 11.5px;
  }

  .sm\\:text-\\[12\\.5px\\]{
    font-size: 12.5px;
  }

  .sm\\:text-\\[13\\.5px\\]{
    font-size: 13.5px;
  }

  .sm\\:text-\\[14px\\]{
    font-size: 14px;
  }

  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .sm\\:text-\\[16px\\]{
    font-size: 16px;
  }

  .sm\\:text-\\[17px\\]{
    font-size: 17px;
  }

  .sm\\:text-\\[18px\\]{
    font-size: 18px;
  }

  .sm\\:text-\\[20px\\]{
    font-size: 20px;
  }

  .sm\\:text-\\[22px\\]{
    font-size: 22px;
  }

  .sm\\:text-\\[24px\\]{
    font-size: 24px;
  }

  .sm\\:text-\\[26px\\]{
    font-size: 26px;
  }

  .sm\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .sm\\:text-\\[30px\\]{
    font-size: 30px;
  }

  .sm\\:text-\\[32px\\]{
    font-size: 32px;
  }

  .sm\\:text-\\[34px\\]{
    font-size: 34px;
  }

  .sm\\:text-\\[36px\\]{
    font-size: 36px;
  }

  .sm\\:text-\\[44px\\]{
    font-size: 44px;
  }

  .sm\\:text-\\[48px\\]{
    font-size: 48px;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:leading-\\[1\\.02\\]{
    line-height: 1.02;
  }

  .sm\\:leading-\\[1\\.05\\]{
    line-height: 1.05;
  }

  .sm\\:leading-\\[1\\.9\\]{
    line-height: 1.9;
  }

  .sm\\:tracking-\\[0\\.4em\\]{
    letter-spacing: 0.4em;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:sticky{
    position: sticky;
  }

  .md\\:top-20{
    top: 5rem;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .md\\:\\!block{
    display: block !important;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:inline-flex{
    display: inline-flex;
  }

  .md\\:grid{
    display: grid;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-auto{
    height: auto;
  }

  .md\\:h-full{
    height: 100%;
  }

  .md\\:max-h-none{
    max-height: none;
  }

  .md\\:min-h-0{
    min-height: 0px;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:flex-1{
    flex: 1 1;
  }

  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[180px_1fr\\]{
    grid-template-columns: 180px 1fr;
  }

  .md\\:grid-cols-\\[180px_minmax\\(0\\2c 1fr\\)_280px\\]{
    grid-template-columns: 180px minmax(0,1fr) 280px;
  }

  .md\\:flex-col{
    flex-direction: column;
  }

  .md\\:overflow-hidden{
    overflow: hidden;
  }

  .md\\:overflow-y-auto{
    overflow-y: auto;
  }

  .md\\:overflow-y-scroll{
    overflow-y: scroll;
  }

  .md\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .md\\:border-b-0{
    border-bottom-width: 0px;
  }

  .md\\:border-l{
    border-left-width: 1px;
  }

  .md\\:border-r{
    border-right-width: 1px;
  }

  .md\\:border-t-0{
    border-top-width: 0px;
  }

  .md\\:p-12{
    padding: 3rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .md\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .md\\:text-\\[17px\\]{
    font-size: 17px;
  }

  .md\\:text-\\[18px\\]{
    font-size: 18px;
  }

  .md\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .md\\:text-\\[30px\\]{
    font-size: 30px;
  }

  .md\\:text-\\[32px\\]{
    font-size: 32px;
  }

  .md\\:text-\\[34px\\]{
    font-size: 34px;
  }

  .md\\:text-\\[36px\\]{
    font-size: 36px;
  }

  .md\\:text-\\[40px\\]{
    font-size: 40px;
  }

  .md\\:text-\\[44px\\]{
    font-size: 44px;
  }

  .md\\:text-\\[52px\\]{
    font-size: 52px;
  }

  .md\\:text-\\[64px\\]{
    font-size: 64px;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:sticky{
    position: sticky;
  }

  .lg\\:top-4{
    top: 1rem;
  }

  .lg\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:min-h-0{
    min-height: 0px;
  }

  .lg\\:w-\\[340px\\]{
    width: 340px;
  }

  .lg\\:flex-1{
    flex: 1 1;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1fr_320px\\]{
    grid-template-columns: 1fr 320px;
  }

  .lg\\:grid-cols-\\[380px_1fr\\]{
    grid-template-columns: 380px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_1\\.1fr\\]{
    grid-template-columns: minmax(0,1fr) 1.1fr;
  }

  .lg\\:overflow-hidden{
    overflow: hidden;
  }

  .lg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:text-\\[48px\\]{
    font-size: 48px;
  }
}
@media (min-width: 1280px){

  .xl\\:block{
    display: block;
  }

  .xl\\:min-w-2{
    min-width: 0.5rem;
  }

  .xl\\:flex-1{
    flex: 1 1;
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .xl\\:text-\\[40px\\]{
    font-size: 40px;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:absolute::-webkit-calendar-picker-indicator{
  position: absolute;
}
.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:right-0::-webkit-calendar-picker-indicator{
  right: 0px;
}
.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:top-0::-webkit-calendar-picker-indicator{
  top: 0px;
}
.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:h-full::-webkit-calendar-picker-indicator{
  height: 100%;
}
.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:w-10::-webkit-calendar-picker-indicator{
  width: 2.5rem;
}
.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:cursor-pointer::-webkit-calendar-picker-indicator{
  cursor: pointer;
}
.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:opacity-0::-webkit-calendar-picker-indicator{
  opacity: 0;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{
  display: none;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>span\\]\\:line-clamp-none>span{
  overflow: visible;
  display: block;
  -webkit-box-orient: horizontal;
  -webkit-line-clamp: none;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_\\[data-cmdk-input-wrapper\\]_svg\\]\\:h-5 [data-cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[data-cmdk-input-wrapper\\]_svg\\]\\:w-5 [data-cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_a\\]\\:text-indigo-600 a{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.\\[\\&_a\\]\\:underline a{
  text-decoration-line: underline;
}
.\\[\\&_blockquote\\]\\:border-l-2 blockquote{
  border-left-width: 2px;
}
.\\[\\&_blockquote\\]\\:border-slate-300 blockquote{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.\\[\\&_blockquote\\]\\:pl-3 blockquote{
  padding-left: 0.75rem;
}
.\\[\\&_blockquote\\]\\:text-slate-600 blockquote{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.\\[\\&_img\\]\\:max-h-10 img{
  max-height: 2.5rem;
}
.\\[\\&_img\\]\\:max-w-full img{
  max-width: 100%;
}
.\\[\\&_li\\]\\:my-0 li{
  margin-top: 0px;
  margin-bottom: 0px;
}
.\\[\\&_li\\]\\:my-0\\.5 li{
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.\\[\\&_ol\\]\\:my-1 ol{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.\\[\\&_ol\\]\\:list-decimal ol{
  list-style-type: decimal;
}
.\\[\\&_ol\\]\\:pl-5 ol{
  padding-left: 1.25rem;
}
.\\[\\&_p\\:last-child\\]\\:mb-0 p:last-child{
  margin-bottom: 0px;
}
.\\[\\&_p\\]\\:m-0 p{
  margin: 0px;
}
.\\[\\&_p\\]\\:mb-2 p{
  margin-bottom: 0.5rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_strong\\]\\:font-semibold strong{
  font-weight: 600;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:\\!max-h-\\[14px\\] svg{
  max-height: 14px !important;
}
.\\[\\&_svg\\]\\:\\!max-w-\\[16px\\] svg{
  max-width: 16px !important;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_table\\]\\:max-w-full table{
  max-width: 100%;
}
.\\[\\&_td\\]\\:align-top td{
  vertical-align: top;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
.\\[\\&_ul\\]\\:my-1 ul{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.\\[\\&_ul\\]\\:list-disc ul{
  list-style-type: disc;
}
.\\[\\&_ul\\]\\:pl-5 ul{
  padding-left: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;QAAA,uBAAc;QAAd,yBAAc;QAAd,iBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,iCAAc;QAAd,sBAAc;QAAd,+BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,qBAAc;QAAd,gCAAc;QAAd,0BAAc;QAAd,mCAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,gBAAc;IAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,wCAAc;EAAd,6BAAc;QAAd;;;AAAc;;AAAd;QAAA,mCAAc;QAAd,uBAAc;IAAA;;AAAd;QAAA,4BAAc;IAAA;;AAAd;QAAA,oBAAc;QAAd,qBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,oBAAc;QAAd,uBAAc;QAAd,mBAAc;QAAd,gBAAc;QAAd,YAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;IAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAoEf;QACI,UAAU;QACV,WAAW;IACf;AACA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;AACA;QACI,4BAA4B;IAChC;AACA;QACI,uBAAuB;IAC3B;AAIA;QACI;;mFAE2E;QAC3E,0BAA0B;IAC9B;AASI;EAAA,8BAAgJ;EAAhJ,mBAAgJ;EAAhJ,2GAAgJ;EAAhJ,yGAAgJ;EAAhJ,4FAAgJ;EAAhJ,oBAAgJ;EAAhJ,4DAAgJ;EAAhJ,2BAAgJ;EAAhJ;AAAgJ;AAnGxJ;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,SAAS;IACT;kBACc;IACd,mCAAmC;IACnC,kCAAkC;IAClC;;iBAEa;AACjB;;AAEA;;;IAGI;;2BAEuB;AAC3B;;AAoFA,4EAA4E;AAC5E;;IAEI,wBAAwB;IACxB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;IAII,2BAA2B;IAC3B,wBAAwB;IACxB,6BAA6B;IAC7B,+BAA+B;IAC/B,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAyBA,4BAA4B;AAC5B;IACI,WAAW,YAAY,EAAE,sBAAsB,EAAE;IACjD,MAAM,UAAU,EAAE,mBAAmB,EAAE;AAC3C;AACA;IACI,gEAAgE;AACpE;;AAEA,kBAAkB;AAClB;IACI,UAAU,UAAU,EAAE;IACtB,YAAY,UAAU,EAAE;AAC5B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA,gFAAgF;AAChF;IACI,kCAAkC;IAClC,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,cAAc;AAClB;AACA;IACI,uBAAuB;AAC3B;;AAEA,yFAAyF;AACzF;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,eAAe;AACnB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;;IAEI,kCAAkC;IAClC,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AA7PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,mBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,iBA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA,QA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,iDA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kDA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,2GA8PA;EA9PA,yGA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,2BA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kDA8PA;EA9PA,2DA8PA;EA9PA;AA8PA;AA9PA;EAAA,kDA8PA;EA9PA,2DA8PA;EA9PA;AA8PA;AA9PA;EAAA,gDA8PA;EA9PA,2DA8PA;EA9PA;AA8PA;AA9PA;EAAA,6EA8PA;EA9PA,iGA8PA;EA9PA;AA8PA;AA9PA;EAAA,0CA8PA;EA9PA,uDA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,8BA8PA;EA9PA;AA8PA;AA9PA;EAAA,2GA8PA;EA9PA,yGA8PA;EA9PA;AA8PA;AA9PA;EAAA,2GA8PA;EA9PA,yGA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,8BA8PA;EA9PA;AA8PA;AA9PA;EAAA,2GA8PA;EA9PA,yGA8PA;EA9PA;AA8PA;AA9PA;EAAA,2GA8PA;EA9PA,yGA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,+EA8PA;EA9PA,mGA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,yBA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,yBA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,qBA8PA;EA9PA;AA8PA;AA9PA;EAAA,qBA8PA;EA9PA;AA8PA;AA9PA;EAAA,gDA8PA;EA9PA;AA8PA;AA9PA;EAAA,iDA8PA;EA9PA;AA8PA;AA9PA;;EAAA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;AAAA;AA9PA;EAAA;AA8PA;AA9PA;;EAAA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;AAAA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,0EA8PA;EA9PA,8FA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,qBA8PA;EA9PA,yBA8PA;EA9PA,2BA8PA;EA9PA,yBA8PA;EA9PA,0BA8PA;EA9PA,+BA8PA;EA9PA;AA8PA;AA9PA;EAAA,qBA8PA;EA9PA,yBA8PA;EA9PA,2BA8PA;EA9PA,yBA8PA;EA9PA,0BA8PA;EA9PA,+BA8PA;EA9PA;AA8PA;AA9PA;EAAA,qBA8PA;EA9PA,yBA8PA;EA9PA,2BA8PA;EA9PA,yBA8PA;EA9PA,0BA8PA;EA9PA,+BA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA,yBA8PA;EA9PA,0BA8PA;EA9PA,wBA8PA;EA9PA,yBA8PA;EA9PA,8BA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA,yBA8PA;EA9PA,0BA8PA;EA9PA,wBA8PA;EA9PA,yBA8PA;EA9PA,8BA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA,yBA8PA;EA9PA,0BA8PA;EA9PA,wBA8PA;EA9PA,yBA8PA;EA9PA,8BA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA,yBA8PA;EA9PA,0BA8PA;EA9PA,wBA8PA;EA9PA,yBA8PA;EA9PA,8BA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA,0BA8PA;EA9PA,qBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,mBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;;EAAA;IAAA,gBA8PA;IA9PA,WA8PA;IA9PA,YA8PA;IA9PA,UA8PA;IA9PA,SA8PA;IA9PA,iBA8PA;IA9PA,UA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,gBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,iBA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,gBA8PA;IA9PA,oBA8PA;IA9PA,4BA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,uBA8PA;IA9PA,sDA8PA;IA9PA;EA8PA;;EA9PA;IAAA,uBA8PA;IA9PA,oDA8PA;IA9PA;EA8PA;;EA9PA;IAAA,uBA8PA;IA9PA,2DA8PA;IA9PA;EA8PA;;EA9PA;IAAA,uBA8PA;IA9PA,8DA8PA;IA9PA;EA8PA;;EA9PA;IAAA,uBA8PA;IA9PA,8DA8PA;IA9PA;EA8PA;;EA9PA;IAAA,uBA8PA;IA9PA,+DA8PA;IA9PA;EA8PA;;EA9PA;IAAA,uBA8PA;IA9PA,4DA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,gBA8PA;IA9PA,uBA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,iBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,oBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,sBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,qBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,kBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,qBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,oBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,qBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,kBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,gBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,qBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,oBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,qBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,mBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,iBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,mBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,iBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,mBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,qBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,iBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,mBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,iBA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,kBA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;AAAA;AA9PA;;EAAA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,oBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,kBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,qBA8PA;IA9PA;EA8PA;;EA9PA;IAAA,iBA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,mBA8PA;IA9PA;EA8PA;AAAA;AA9PA;;EAAA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,oBA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;AAAA;AA9PA;;EAAA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA;EA8PA;;EA9PA;IAAA,oBA8PA;IA9PA;EA8PA;;EA9PA;IAAA;EA8PA;AAAA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kDA8PA;EA9PA;AA8PA;AA9PA;EAAA,iDA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,iDA8PA;EA9PA;AA8PA;AA9PA;EAAA,kDA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kDA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,qBA8PA;EA9PA;AA8PA;AA9PA;EAAA,gBA8PA;EA9PA,oBA8PA;EA9PA,4BA8PA;EA9PA;AA8PA;AA9PA;EAAA,iBA8PA;EA9PA,cA8PA;EA9PA,8BA8PA;EA9PA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,WA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA,mBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,qBA8PA;EA9PA;AA8PA;AA9PA;EAAA,kBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,sBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,eA8PA;EA9PA;AA8PA;AA9PA;EAAA,oBA8PA;EA9PA;AA8PA;AA9PA;EAAA,mBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,WA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA,mBA8PA;EA9PA;AA8PA;AA9PA;EAAA;AA8PA;AA9PA;EAAA;AA8PA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700;800&family=Geist+Mono:wght@400;500;600&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n    margin: 0;\n    font-family: \"Geist\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-feature-settings:\n        \"ss01\" on,\n        \"cv11\" on;\n}\n\ncode,\npre,\n.font-mono {\n    font-family:\n        \"Geist Mono\", \"JetBrains Mono\", ui-monospace, SFMono-Regular, Menlo,\n        Consolas, monospace;\n}\n\n@layer base {\n    :root {\n        --background: 0 0% 100%;\n        --foreground: 222 47% 11%;\n        --card: 0 0% 100%;\n        --card-foreground: 222 47% 11%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 222 47% 11%;\n        --primary: 243 75% 59%;\n        --primary-foreground: 0 0% 100%;\n        --secondary: 210 40% 96%;\n        --secondary-foreground: 222 47% 11%;\n        --muted: 210 40% 96%;\n        --muted-foreground: 215 16% 47%;\n        --accent: 210 40% 96%;\n        --accent-foreground: 222 47% 11%;\n        --destructive: 346 84% 47%;\n        --destructive-foreground: 0 0% 100%;\n        --border: 214 32% 91%;\n        --input: 214 32% 91%;\n        --ring: 243 75% 59%;\n        --chart-1: 243 75% 59%;\n        --chart-2: 160 84% 39%;\n        --chart-3: 199 89% 48%;\n        --chart-4: 38 92% 50%;\n        --chart-5: 346 84% 47%;\n        --radius: 0.5rem;\n    }\n}\n\n@layer base {\n    * {\n        @apply border-border;\n    }\n    body {\n        @apply bg-background text-foreground;\n        font-feature-settings:\n            \"rlig\" 1,\n            \"calt\" 1;\n    }\n    ::selection {\n        background: hsl(243 75% 59% / 0.18);\n        color: hsl(243 75% 30%);\n    }\n}\n\n@layer utilities {\n    .scrollbar-thin::-webkit-scrollbar {\n        width: 6px;\n        height: 6px;\n    }\n    .scrollbar-thin::-webkit-scrollbar-thumb {\n        background: hsl(215 20% 85%);\n        border-radius: 3px;\n    }\n    .scrollbar-thin::-webkit-scrollbar-thumb:hover {\n        background: hsl(215 20% 70%);\n    }\n    .scrollbar-thin::-webkit-scrollbar-track {\n        background: transparent;\n    }\n    .text-balance {\n        text-wrap: balance;\n    }\n    .bg-grid {\n        background-image:\n            linear-gradient(to right, hsl(214 32% 91% / 0.4) 1px, transparent 1px),\n            linear-gradient(to bottom, hsl(214 32% 91% / 0.4) 1px, transparent 1px);\n        background-size: 32px 32px;\n    }\n    .bg-dot {\n        background-image: radial-gradient(\n            hsl(215 20% 80%) 1px,\n            transparent 1px\n        );\n        background-size: 18px 18px;\n    }\n    .ring-focus {\n        @apply focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white;\n    }\n}\n\n/* PasswordInput — hide native reveal/clear controls (custom toggle only). */\n.password-input-field::-ms-reveal,\n.password-input-field::-ms-clear {\n    display: none !important;\n    width: 0 !important;\n    height: 0 !important;\n}\n\n.password-input-field::-webkit-credentials-auto-fill-button,\n.password-input-field::-webkit-password-reveal-button,\n.password-input-field::-webkit-caps-lock-indicator {\n    -webkit-appearance: none !important;\n    appearance: none !important;\n    display: none !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n    width: 0 !important;\n    height: 0 !important;\n    margin: 0 !important;\n    opacity: 0 !important;\n}\n\n.password-input-field::-moz-password-reveal {\n    display: none !important;\n}\n\n.password-input-field[type=\"password\"]::-webkit-textfield-decoration-container {\n    visibility: hidden !important;\n    pointer-events: none !important;\n    width: 0 !important;\n    height: 0 !important;\n    overflow: hidden !important;\n}\n\n@layer base {\n    [data-debug-wrapper=\"true\"] {\n        display: contents !important;\n    }\n    [data-debug-wrapper=\"true\"] > * {\n        margin-left: inherit;\n        margin-right: inherit;\n        margin-top: inherit;\n        margin-bottom: inherit;\n        padding-left: inherit;\n        padding-right: inherit;\n        padding-top: inherit;\n        padding-bottom: inherit;\n        column-gap: inherit;\n        row-gap: inherit;\n        gap: inherit;\n        border-left-width: inherit;\n        border-right-width: inherit;\n        border-top-width: inherit;\n        border-bottom-width: inherit;\n    }\n}\n\n/* Streaming dot animation */\n@keyframes pulse-soft {\n    0%, 100% { opacity: 0.4; transform: scale(0.85); }\n    50% { opacity: 1; transform: scale(1); }\n}\n.pulse-dot {\n    animation: pulse-soft 1.1s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Typing cursor */\n@keyframes blink {\n    0%, 49% { opacity: 1; }\n    50%, 100% { opacity: 0; }\n}\n.typing-cursor::after {\n    content: \"▍\";\n    margin-left: 1px;\n    color: hsl(243 75% 59%);\n    animation: blink 1s steps(1) infinite;\n}\n\n/* Native <dialog> overlays: strip UA light-gray sheet; keep positioning only. */\ndialog.modal-overlay {\n    background: transparent !important;\n    border: none;\n    padding: 0;\n    max-width: none;\n    max-height: none;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    color: inherit;\n}\ndialog.modal-overlay::backdrop {\n    background: transparent;\n}\n\n/* Brain playground: render server-sanitized answer_html only (formatting done in API). */\n.brain-playground-answer {\n    font-size: 13px;\n    line-height: 1.55;\n    color: rgb(30 41 59);\n    word-break: break-word;\n}\n.brain-playground-answer p {\n    margin: 0 0 0.65em;\n}\n.brain-playground-answer p:last-child {\n    margin-bottom: 0;\n}\n.brain-playground-answer ul,\n.brain-playground-answer ol {\n    margin: 0.5em 0;\n    padding-left: 1.25rem;\n}\n.brain-playground-answer ul {\n    list-style-type: disc;\n}\n.brain-playground-answer ol {\n    list-style-type: decimal;\n}\n.brain-playground-answer li {\n    margin: 0.2em 0;\n}\n.brain-playground-answer strong,\n.brain-playground-answer b {\n    font-weight: 600;\n}\n.brain-playground-answer table {\n    border-collapse: collapse;\n    width: 100%;\n    max-width: 100%;\n    margin: 0.65em 0;\n    font-size: 12px;\n}\n.brain-playground-answer th,\n.brain-playground-answer td {\n    border: 1px solid rgb(203 213 225);\n    padding: 0.4em 0.55em;\n    vertical-align: top;\n    text-align: left;\n    word-break: break-word;\n}\n.brain-playground-answer th {\n    background: rgb(241 245 249);\n    font-weight: 600;\n}\n.brain-playground-answer--plain {\n    white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
